// src/lib/track.js
// Tracking de tunnel campagne, first-party (jumeau de ArtkivVisionApp/src/lib/track.ts).
// Écrit dans public.funnel_events. Ne casse JAMAIS le parcours (tout est encapsulé).
import { supabase } from "@/lib/supabaseClient";

const AID_KEY = "artkiv_aid";

// Identifiant pseudonyme persistant. Sur artkiv.com c'est ici qu'il naît, puis on
// le propage au quiz (vision.artkiv.com) via ?aid= pour relier visite → quiz.
export function getAnonId() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("aid");
    if (fromUrl) {
      localStorage.setItem(AID_KEY, fromUrl);
      return fromUrl;
    }
    let id = localStorage.getItem(AID_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : String(Date.now()) + Math.random();
      localStorage.setItem(AID_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

// Ajoute ?aid=<anon_id> à une URL (pour propager l'identifiant au domaine du quiz).
export function withAid(url) {
  try {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}aid=${encodeURIComponent(getAnonId())}`;
  } catch {
    return url;
  }
}

export async function track(event, opts = {}) {
  try {
    await supabase.from("funnel_events").insert({
      anon_id: getAnonId(),
      event,
      email: opts.email ?? null,
      referrer_aid: opts.referrerAid ?? null,
      meta: opts.meta ?? null,
    });
  } catch {
    /* silencieux */
  }
}
